export type FaqItem = {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: 'Is this a physical product?',
    answer:
      "No — it's 100% digital. You print at home as many times as you want. Nothing ships, nothing to wait for.",
  },
  {
    question: 'What ages is this for?',
    answer:
      'Ages 2 to 10. Younger kids follow the picture cards; older kids use the checklist charts and reward boards.',
  },
  {
    question: 'Do I need a special printer or paper?',
    answer:
      'No. Regular home printer, regular paper. Everything comes in US Letter and A4, in color and in an ink-saving black & white version. Laminate them or slip them in a sheet protector if you want them to last.',
  },
  {
    question: 'My kid has ADHD or is autistic. Will this work?',
    answer:
      'Yes — visual schedules are one of the most widely used supports for neurodivergent kids, exactly because they remove the working-memory load of verbal instructions. Many families use these as first-then boards.',
  },
  {
    question: "Can I add my kid's name and our own routine?",
    answer:
      "The core kit comes with a fillable checklist. For full editing — your kid's name, your exact activities, your own icons — add the editable Canva version at checkout.",
  },
  {
    question: 'How fast do I get it?',
    answer:
      'Instantly. The moment your payment goes through, the link to your private library lands in your inbox — no shipping, nothing to wait for. Check your spam folder, and email us any time if anything goes wrong.',
  },
  {
    question: "What if it doesn't work for us?",
    answer: '30 days, full refund, no questions asked — and you keep the bonuses.',
  },
  {
    question: 'Is my payment secure?',
    answer: 'Yes. Checkout is fully encrypted and we never see or store your card details.',
  },
]
